import * as angular from "angular";
import {DateRangeTemplateType} from "../types/date-range-template.type";

export class DateRangeTimeFiltersService {
  private readonly DateRangeFilterIdToFunction: {};

  constructor(private $filter, private moment) {
    this.DateRangeFilterIdToFunction = {
      [DateRangeTemplateType.YESTERDAY]: this.yesterday(),
      [DateRangeTemplateType.TODAY]: this.today(),
      [DateRangeTemplateType.TOMORROW]: this.tomorrow(),
      [DateRangeTemplateType.THIS_WEEK]: this.thisWeek(),
      [DateRangeTemplateType.CALENDAR_WEEK]: this.thisCalendarWeek(),
      [DateRangeTemplateType.LAST_WEEK]: this.lastWeek(),
      [DateRangeTemplateType.NEXT_WEEK]: this.nextWeek(),
      [DateRangeTemplateType.PAST_WEEK]: this.pastWeek(),
      [DateRangeTemplateType.THIS_MONTH]: this.thisMonth(),
      [DateRangeTemplateType.CALENDAR_MONTH]: this.thisCalendarMonth(),
      [DateRangeTemplateType.LAST_MONTH]: this.lastMonth(),
      [DateRangeTemplateType.NEXT_MONTH]: this.nextMonth(),
      [DateRangeTemplateType.THIS_YEAR]: this.thisYear(),
      [DateRangeTemplateType.PAST_YEAR]: this.pastYear(),
      [DateRangeTemplateType.PREVIOUS_YEAR]: this.previousYear()
    }
  }

  getDateRangeFilterByType(type: DateRangeTemplateType) {
    return this.DateRangeFilterIdToFunction[type];
  }

  yesterday() {
    return {
      name: 'Yesterday',
      type: DateRangeTemplateType.YESTERDAY,
      dateStart: this.moment().subtract(1, 'day').startOf('day').valueOf(),
      dateEnd: this.moment().subtract(1, 'day').endOf('day').valueOf()
    };
  }

  today() {
    return {
      name: 'Today',
      type: DateRangeTemplateType.TODAY,
      dateStart: this.moment().startOf('day').valueOf(),
      dateEnd: this.moment().endOf('day').valueOf()
    };
  }

  tomorrow() {
    return {
      name: 'Tomorrow',
      type: DateRangeTemplateType.TOMORROW,
      dateStart: this.moment().add(1, 'day').startOf('day').valueOf(),
      dateEnd: this.moment().add(1, 'day').endOf('day').valueOf()
    };
  }

  thisWeek() {
    return {
      name: 'This Week',
      type: DateRangeTemplateType.THIS_WEEK,
      dateStart: this.moment().startOf('week').valueOf(),
      dateEnd: this.moment().endOf('day').valueOf()
    };
  }

  thisCalendarWeek() {
    return {
      name: 'Calendar Week',
      type: DateRangeTemplateType.CALENDAR_WEEK,
      dateStart: this.moment().startOf('week').valueOf(),
      dateEnd: this.moment().endOf('week').valueOf()
    };
  }

  lastWeek() {
    return {
      name: 'Last Week',
      type: DateRangeTemplateType.LAST_WEEK,
      dateStart: this.moment().subtract(1, 'week').startOf('week').valueOf(),
      dateEnd: this.moment().subtract(1, 'week').endOf('week').valueOf()
    };
  }

  nextWeek() {
    return {
      name: 'Next Week',
      type: DateRangeTemplateType.NEXT_WEEK,
      dateStart: this.moment().add(1, 'week').startOf('week').valueOf(),
      dateEnd: this.moment().add(1, 'week').endOf('week').valueOf()
    };
  }

  pastWeek() {
    return {
      name: 'Past Week',
      type: DateRangeTemplateType.PAST_WEEK,
      dateStart: this.moment().subtract(1, 'week').startOf('day').valueOf(),
      dateEnd: this.moment().subtract(1, 'day').endOf('day').valueOf()
    };
  }

  thisMonth() {
    return {
      name: 'This Month',
      type: DateRangeTemplateType.THIS_MONTH,
      dateStart: this.moment().startOf('month').valueOf(),
      dateEnd: this.moment().endOf('day').valueOf()
    }
  }

  thisCalendarMonth() {
    return {
      name: 'Calendar Month',
      type: DateRangeTemplateType.CALENDAR_MONTH,
      dateStart: this.moment().startOf('month').valueOf(),
      dateEnd: this.moment().endOf('month').valueOf()
    }
  }

  lastMonth() {
    return {
      name: 'Last Month',
      type: DateRangeTemplateType.LAST_MONTH,
      dateStart: this.moment().subtract(1, 'months').startOf('month').valueOf(),
      dateEnd: this.moment().subtract(1, 'months').endOf('month').valueOf()
    }
  }

  nextMonth() {
    return {
      name: 'Next Month',
      type: DateRangeTemplateType.NEXT_MONTH,
      dateStart: this.moment().add(1, 'months').startOf('month').valueOf(),
      dateEnd: this.moment().add(1, 'months').endOf('month').valueOf()
    }
  }

  thisYear() {
    return {
      name: 'This Year',
      type: DateRangeTemplateType.THIS_YEAR,
      dateStart: this.moment().startOf('year').valueOf(),
      dateEnd: this.moment().endOf('day').valueOf()
    }
  }

  pastYear() {
    return {
      name: 'Past Year',
      type: DateRangeTemplateType.PAST_YEAR,
      dateStart: this.moment().subtract(1, 'years').startOf('day').valueOf(),
      dateEnd: this.moment().endOf('day').valueOf()
    }
  }

  previousYear() {
    return {
      name: 'Previous Year',
      type: DateRangeTemplateType.PREVIOUS_YEAR,
      dateStart: this.moment().subtract(1, 'years').startOf('year').valueOf(),
      dateEnd: this.moment().subtract(1, 'years').endOf('year').valueOf()
    }
  }


  // ******************************
  // Custom Templates
  // ******************************

  getDefaultCustomTemplates() {
    return [
      this.yesterday(),
      this.today(),
      this.tomorrow(),
      this.thisWeek(),
      this.thisCalendarWeek(),
      this.lastWeek(),
      this.thisCalendarMonth(),
      this.lastMonth(),
      this.thisMonth(),
      this.thisYear(),
      this.pastYear(),
      this.previousYear()
    ]
  }

  getReportCustomTemplates() {
    return [
      this.pastWeek(),
      this.thisWeek(),
      this.lastWeek(),
      this.thisMonth(),
      this.lastMonth(),
    ]
  }

  getBillingAccountCustomTemplates() {
    return [
      this.yesterday(),
      this.today(),
      this.tomorrow(),
      this.thisMonth()
    ]
  }

  getCommissionsCustomTemplates() {
    return [
      this.yesterday(),
      this.today(),
      this.tomorrow(),
      this.lastWeek(),
      this.thisWeek(),
      this.thisCalendarWeek(),
      this.lastMonth(),
      this.thisMonth(),
      this.thisCalendarMonth(),
      this.thisYear(),
      this.pastYear(),
      this.previousYear()
    ]
  }

  getDeliveriesCustomTemplates() {
    return [
      this.yesterday(),
      this.today(),
      this.tomorrow(),
      this.lastWeek(),
      this.thisWeek(),
      this.thisCalendarWeek(),
      this.lastMonth(),
      this.thisMonth(),
      this.thisCalendarMonth(),
    ]
  }

  getBillingCustomTemplates() {
    return [
      this.yesterday(),
      this.today(),
      this.tomorrow(),
      this.lastWeek(),
      this.thisWeek(),
      this.thisCalendarWeek(),
      this.lastMonth(),
      this.thisMonth(),
      this.thisCalendarMonth(),
      this.thisYear(),
      this.pastYear(),
      this.previousYear()
    ]
  }

  getDeliveryHistoryCustomTemplates() {
    return [
      this.yesterday(),
      this.today(),
      this.lastMonth(),
      this.thisMonth(),
      this.thisWeek(),
      this.lastWeek()
    ]
  }

  getSiteMarketCustomTemplates() {
    return [
      this.today(),
      this.tomorrow(),
      this.nextWeek(),
      this.nextMonth()
    ]
  }

  getTimekeepingCustomTemplates() {
    return [
      this.thisWeek(),
      this.thisCalendarWeek(),
      this.lastWeek()
    ]
  }

  getLocalizationValues() {
    return {
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
      Cancel: "Cancel",
      Clear: "Clear",
      Ok: "Ok"
    }
  }

  getRangeDisplay(from?, to?, dateFormat?, noNames?, displayTime?) {
    // From
    let dayFrom = this.moment(from).get('date'),
      monthFrom = this.moment(from).get('month'),
      yearFrom = this.moment(from).get('year');

    // To
    let dayTo = this.moment(to).get('date'),
      monthTo = this.moment(to).get('month'),
      yearTo = this.moment(to).get('year');

    let displayFromValue = this.moment(from).format(dateFormat.long),
      displayToValue = this.moment(to).format(dateFormat.long);

    if (yearFrom !== yearTo) {
      if (displayTime) {
        displayFromValue += ' ' + this.moment(from).format(dateFormat.time);
        displayToValue += ' ' + this.moment(to).format(dateFormat.time);
      }
      return displayFromValue + ' - ' + displayToValue
    } else if (monthFrom !== monthTo || dayFrom !== dayTo) {
      var yearValue = this.moment(to).format('YYYY');
      displayFromValue = this.moment(from).format(dateFormat.date);
      displayToValue = this.moment(to).format(dateFormat.date);

      if (displayTime) {
        displayFromValue += ' ' + this.moment(from).format(dateFormat.time);
        displayToValue += ' ' + this.moment(to).format(dateFormat.time);
      }

      return displayFromValue + ' - ' + displayToValue + ' ' + yearValue;
    } else if (this.moment(from).isSame(this.moment(), 'date')) {
      if (!noNames) {
        return this.$filter('translate')('Today')
      } else {
        if (displayTime) {
          displayFromValue += ' ' + this.moment(from).format(dateFormat.time) + ' - ' + this.moment(to).format(dateFormat.time)
        }
        return displayFromValue;
      }
    } else {
      if (displayTime) {
        displayFromValue += ' ' + this.moment(from).format(dateFormat.time) + ' - ' + this.moment(to).format(dateFormat.time);
      }
      return displayFromValue;
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .service('dateRangeTimeFiltersService', DateRangeTimeFiltersService);
